import RRS from 'constants/recurrence/recurrenceRuleSimplified.const';

const RECURRENCE_DESCRIPTION = Object.freeze({
  null: 'scheduler.scheduleEvent.recurrence.today',
  [RRS.onlyOnce]: 'scheduler.scheduleEvent.recurrence.noRepeat',
  [RRS.every1Day]: 'scheduler.scheduleEvent.recurrence.daily',
  [RRS.every1Week]: 'scheduler.scheduleEvent.recurrence.weekly',
  [RRS.every2Weeks]: 'scheduler.scheduleEvent.recurrence.twoWeeks',
  [RRS.every4Weeks]: 'scheduler.scheduleEvent.recurrence.fourWeeks',
  [RRS.every6Weeks]: 'scheduler.scheduleEvent.recurrence.sixWeeks',
});

export default RECURRENCE_DESCRIPTION;
